import { TypedUseSelectorHook, useSelector } from "react-redux"
import { RootState } from "appRedux/store"

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
